(function () {
  'use strict';
  if (window.__persaGiftRecovery) return;
  window.__persaGiftRecovery = true;
  const config = document.querySelector('script[data-persa-gift]');
  const C = window.PersaGiftCore;
  if (!config || !C) return;
  const endpoint = config.dataset.endpoint;
  const language = config.dataset.language.startsWith('en') ? 'en' : 'es';
  const root = config.dataset.root.replace(/\/?$/, '/');
  const originalFetch = window.fetch.bind(window);
  const SESSION = 'persa_gift_recovery_v1';
  const BACKUP = 'persa_gift_backup_v1';
  const phrases = language === 'en' ? {
    heading:'Your saved gift', review:'Your flowers and personal touches, just as you left them.',
    restore:'Restore this gift', keep:'Keep my current basket', conflict:'Your basket currently contains a different selection. Restoring this gift will replace it.',
    busy:'Restoring your gift…', expired:'This saved gift is unavailable or has expired. Your current basket has not changed.',
    dateHeading:'Confirm the delivery date', date:'Choose a date and time in the calendar, then confirm them here before continuing.',
    check:'I confirm this delivery date and time', needed:'Please choose an available date and time in the calendar and confirm them here.',
    failed:'We could not restore every option at the correct price. Please contact us before paying.',
    rollback:'Your previous basket has been restored.', help:'Contact Persa', saved:'Your gift has been restored. Choose delivery in the calendar, then confirm it here.',
    step:'YOUR SAVED SELECTION', next:'Next: choose delivery', nextHelp:'Restore your gift, then choose an available date and time before checkout.', allOptions:'View all options', message:'Your message', quantity:'Qty', each:'each', savedDate:'Previously selected', dateHelp:'You’ll choose and confirm a new date in the next step.', loading:'Loading your saved gift…', details:'Gift details', note:'Recipient contact / order note', previous:'Previously selected date (please choose again): ',
    recoveryHelp:'Your previous basket is saved in this browser while we resolve this.', price:'Item price',
    unavailable:'Recovery is incomplete. Please contact us before paying.'
  } : {
    heading:'Tu regalo guardado', review:'Tus flores y cada detalle, tal como los dejaste.',
    restore:'Recuperar este regalo', keep:'Conservar mi carrito actual', conflict:'Tu carrito contiene otra selección. Al recuperar este regalo, se sustituirá por el regalo guardado.',
    busy:'Recuperando tu regalo…', expired:'Este regalo guardado no está disponible o ha caducado. Tu carrito actual no ha cambiado.',
    dateHeading:'Confirma la fecha de entrega', date:'Elige una fecha y una hora en el calendario y confírmalas aquí antes de continuar.',
    check:'Confirmo esta fecha y hora de entrega', needed:'Elige una fecha y una hora disponibles en el calendario y confírmalas aquí.',
    failed:'No hemos podido recuperar todas las opciones con el precio correcto. Contacta con nosotros antes de pagar.',
    rollback:'Hemos recuperado tu carrito anterior.', help:'Contactar con Persa', saved:'Tu regalo está recuperado. Elige la entrega en el calendario y confírmala aquí.',
    step:'TU SELECCIÓN GUARDADA', next:'Después, elige la entrega', nextHelp:'Recupera tu regalo y elige una fecha y hora disponibles antes de continuar con el pedido.', allOptions:'Ver todas las opciones', message:'Tu dedicatoria', quantity:'Cant.', each:'unidad', savedDate:'Fecha anterior', dateHelp:'En el siguiente paso elegirás y confirmarás una nueva fecha.', loading:'Cargando tu regalo guardado…', details:'Detalles del regalo', note:'Contacto del destinatario / nota del pedido', previous:'Fecha elegida anteriormente (elige de nuevo): ',
    recoveryHelp:'Tu carrito anterior está guardado en este navegador mientras lo resolvemos.', price:'Precio del artículo',
    unavailable:'La recuperación no está completa. Contacta con nosotros antes de pagar.'
  };
  const money = cents => new Intl.NumberFormat(language === 'en' ? 'en-IE' : 'es-ES', {style:'currency',currency:'EUR'}).format(cents/100);
  let internalMutation = false, timer, captureBusy = false, repeatCapture = false, lastSaved = '';
  let reviewing = false;
  let recovery = null, selectionAt = 0, selectedDay = '', verifiedSelection = null, checking = false;
  try { recovery = JSON.parse(sessionStorage.getItem(SESSION) || 'null'); } catch (_) {}
  if (recovery && Date.now()-recovery.started>7*86400000) { sessionStorage.removeItem(SESSION); recovery=null; }
  function element(tag, text, attrs = {}) {
    const el = document.createElement(tag); if (text) el.textContent = text;
    for (const [k,v] of Object.entries(attrs)) el.setAttribute(k,v);
    return el;
  }
  function storage(key, value) { sessionStorage.setItem(key, JSON.stringify(value)); }
  function randomKey() { return [...crypto.getRandomValues(new Uint8Array(32))].map(b=>b.toString(16).padStart(2,'0')).join(''); }
  async function request(url, options) {
    const controller = new AbortController();
    const timeout = setTimeout(()=>controller.abort(),5000);
    let response;
    try { response = await originalFetch(url, {...options,signal:controller.signal}); } finally { clearTimeout(timeout); }
    if (!response.ok) throw new Error('Request failed '+response.status+' '+new URL(url,location.origin).pathname.replace(/(\/recover\/).*/, '$1[private]')); 
    return response.json();
  }
  async function cart(action, payload) {
    if (action === 'read') return request(root+'cart.js', {cache:'no-store'});
    return request(root+'cart/'+action+'.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
  }
  async function service(path, payload) {
    return request(endpoint+path, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),credentials:'omit',referrerPolicy:'no-referrer'});
  }
  function qaStatus(text){
    if(config.dataset.qa!=='true')return;
    let p=document.getElementById('pf-gift-qa-status');
    if(!p){p=element('p','',{id:'pf-gift-qa-status'});document.querySelector('main')?.append(p);}
    p.textContent='Prueba interna: '+text;
  }
  function allowed() { return Boolean(window.Shopify?.customerPrivacy?.marketingAllowed?.()); }
  function scheduleCapture() {
    if (internalMutation || recovery || reviewing || !allowed()) return;
    clearTimeout(timer); timer = setTimeout(()=>{capture();setTimeout(capture,2000);},650);
  }
  async function capture(forCheckout=false) {
    if (!allowed() || (recovery && !forCheckout) || reviewing || internalMutation){qaStatus(!allowed()?'pendiente de permiso de marketing':'recuperación activa');return;}
    if (captureBusy) { repeatCapture = true; return; }
    captureBusy = true;
    try {
      let current = await cart('read');
      if (!current.items.length) return;
      const tokenHash = [...new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(current.token)))].map(b=>b.toString(16).padStart(2,'0')).join('');
      const slot = 'persa_gift_writer_'+tokenHash;
      let keys;
      try { keys = JSON.parse(localStorage.getItem(slot) || 'null'); } catch (_) {}
      if (!keys || Date.now()-keys.created > 6*86400000) {
        keys = {read_key:randomKey(),write_key:randomKey(),created:Date.now()};
        localStorage.setItem(slot,JSON.stringify(keys));
      }
      const noteInput=document.querySelector('textarea[name=note]');
      if(noteInput)current.note=noteInput.value;
      const snapshot = C.capture(current,language);
      // Internal recovery attributes are not part of the gift or captured recursively.
      snapshot.attributes = Object.fromEntries(Object.entries(snapshot.attributes).filter(([k])=>!k.startsWith('_pf_recovery')));
      qaStatus('guardando '+snapshot.items.length+' artículos');
      const body = {read_key:keys.read_key,write_key:keys.write_key,snapshot};
      const serialized = JSON.stringify(body);
      if (serialized !== lastSaved) {
        await service('/v1/snapshots',body);
        if (current.attributes._pf_recovery_key !== keys.read_key) {
          internalMutation = true;
          try { await cart('update',{attributes:{_pf_recovery_key:keys.read_key}}); } finally { internalMutation = false; }
        }
        lastSaved = serialized;
      }
      // Pixel shares only native event IDs via Shopify's documented cookie API.
      // Read/write capabilities stay in this storefront and go directly to Persa's API.
      const cookie=document.cookie.split('; ').find(c=>c.startsWith('pf_gift_events='));
      if(cookie){
        let events=[];try{events=JSON.parse(decodeURIComponent(cookie.slice('pf_gift_events='.length)));}catch(_){}
        if(Array.isArray(events))for(const event of events.slice(-8)){
          if(Math.abs(Date.now()-event.timestamp)>60000 || !snapshot.items.some(i=>i.id===event.variant_id))continue;
          qaStatus('evento '+event.id);
          await service('/v1/aliases',{read_key:keys.read_key,write_key:keys.write_key,event_id:event.id,variant_id:event.variant_id});
          if(config.dataset.qa==='true'){
            let a=document.getElementById('pf-gift-qa-event');
            if(!a){a=element('a','Prueba interna: enlace del evento añadido',{id:'pf-gift-qa-event'});document.querySelector('main').append(a);}
            a.href=root+'cart#pf-gift='+event.id;
          }
        }
      }
      if(config.dataset.qa==='true'){
        let link=document.getElementById('pf-gift-qa-link');
        if(!link){link=element('a','Prueba interna: abrir regalo guardado',{id:'pf-gift-qa-link'});document.querySelector('main').append(link);}
        link.href=root+'cart#pf-gift='+keys.read_key;
        qaStatus('guardado: '+snapshot.items.length+' artículos');
      }
    } catch (error) { qaStatus(error.message); /* Normal shopping remains usable. */ }
    finally { captureBusy = false; if (repeatCapture) { repeatCapture=false; scheduleCapture(); } }
  }
  function observeURL(value) {
    try { const u = new URL(typeof value === 'string' ? value : value.url,location.origin); return u.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname); } catch (_) { return false; }
  }
  window.fetch = function (...args) {
    const watched = observeURL(args[0]);
    return originalFetch(...args).then(response => { if (watched && response.ok && !internalMutation) { invalidate(); scheduleCapture(); } return response; });
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (observeURL(url)) this.addEventListener('load',() => { if (this.status>=200 && this.status<300 && !internalMutation) { invalidate(); scheduleCapture(); } }, {once:true});
    return xhrOpen.call(this,method,url,...rest);
  };
  function panel(id, title) {
    let p = document.getElementById(id); if (p) return p;
    p = element('section','',{id,class:'pf-gift-panel','aria-label':title});
    p.append(element('h2',title));
    (document.querySelector('#MainContent') || document.querySelector('main')).prepend(p);
    return p;
  }
  const css = element('style');
  css.textContent = `
    .pf-gift-panel{box-sizing:border-box;color:#202521;font:400 15px/1.5 var(--font-body-family,"Schibsted Grotesk",sans-serif);letter-spacing:normal}
    .pf-gift-panel *{box-sizing:border-box;min-width:0}
    #pf-gift-review{max-width:1080px;margin:32px auto 48px;padding:0 24px;background:#fff}
    .pf-gift-panel h2,.pf-gift-panel h3{font-family:var(--font-heading-family,Newsreader,serif);font-weight:400;letter-spacing:-.025em;color:inherit}
    .pf-gift-panel h2{font-size:36px;line-height:1.1;margin:0 0 12px}
    .pf-gift-panel p{margin:8px 0;overflow-wrap:anywhere}
    .pf-gift-panel .pf-gift-eyebrow{font-size:11px;letter-spacing:.14em;font-weight:600;color:#526359;margin:0 0 12px}
    .pf-gift-intro{color:#5c625b;max-width:58ch;margin-bottom:24px!important}
    .pf-gift-layout{display:grid;grid-template-columns:minmax(0,1fr) 300px;gap:24px;align-items:start}
    .pf-gift-items{list-style:none;padding:0;margin:0;display:grid;gap:12px}
    .pf-gift-item{padding:20px;border:1px solid #e3e3dc;border-radius:6px;background:#fff;overflow-wrap:anywhere}
    .pf-gift-item-top{display:flex;align-items:center;gap:14px}
    .pf-gift-thumb{width:64px;height:80px;object-fit:contain;background:#f6f4ee;border-radius:3px;flex-shrink:0}
    .pf-gift-item-info{flex:1}
    .pf-gift-item h3{font-size:23px;line-height:1.15;margin:0 0 5px}
    .pf-gift-meta{color:#63675f;font-size:13px;margin:3px 0!important}
    .pf-gift-price{font-size:14px;font-weight:600;white-space:nowrap}
    .pf-gift-price small{display:block;font-size:11px;font-weight:400;color:#63675f}
    .pf-gift-message{margin:16px 0 0;padding:16px;background:#f6f4ee;border-left:2px solid #8d9b88;border-radius:0 4px 4px 0}
    .pf-gift-message .pf-gift-message-label{font-size:11px;font-weight:600;letter-spacing:.09em;text-transform:uppercase;color:#526359;margin:0 0 7px}
    .pf-gift-message blockquote{border:0;padding:0;margin:0;font:400 20px/1.4 var(--font-heading-family,Newsreader,serif);white-space:pre-wrap;overflow-wrap:anywhere;color:#202521}
    .pf-gift-personal{display:flex;flex-wrap:wrap;gap:4px 18px;margin-top:10px;font-size:12px;color:#526359}
    .pf-gift-personal p{margin:0;white-space:pre-wrap}
    .pf-gift-option-summary{font-size:13px;color:#526359;margin-top:12px!important}
    .pf-gift-options{margin-top:12px;border-top:1px solid #eeeee8}
    .pf-gift-options summary{display:flex;align-items:center;justify-content:space-between;gap:12px;cursor:pointer;list-style:none;min-height:44px;font-size:13px;font-weight:500;color:#24463a;padding:8px 0}
    .pf-gift-options summary::-webkit-details-marker{display:none}
    .pf-gift-options summary::after{content:'+';font-size:22px;font-weight:400}
    .pf-gift-options[open] summary::after{content:'−'}
    .pf-gift-options dl{margin:0 0 4px;font-size:13px}
    .pf-gift-option{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.3fr);gap:12px;padding:6px 0;border-top:1px solid #f0f0eb}
    .pf-gift-option dt{color:#63675f}.pf-gift-option dd{margin:0;white-space:pre-wrap;overflow-wrap:anywhere}
    .pf-gift-next{position:sticky;top:24px;border:1px solid #e3e3dc;border-radius:6px;background:#f6f4ee;padding:22px}
    .pf-gift-next h3{font-size:25px;line-height:1.15;margin:0 0 10px}
    .pf-gift-next p{font-size:13px;color:#526359}
    .pf-gift-previous{border-top:1px solid #dcdfd5;padding-top:12px;margin-top:16px!important}
    .pf-gift-conflict{font-size:12px!important;color:#62644f!important;border-top:1px solid #dcdfd5;padding-top:12px;margin:14px 0!important}
    .pf-gift-contact{padding:12px 4px;font-size:13px;color:#63675f;white-space:pre-wrap;overflow-wrap:anywhere}
    .pf-gift-actions{display:grid;gap:8px;margin-top:18px}
    .pf-gift-panel button{min-height:48px;padding:12px 16px;border:1px solid #24463a;border-radius:3px;background:#24463a;color:#fff;font:500 14px/1.35 var(--font-body-family,"Schibsted Grotesk",sans-serif);letter-spacing:normal;cursor:pointer;white-space:normal;touch-action:manipulation}
    .pf-gift-panel button:hover{background:#18372c}.pf-gift-panel button:disabled{opacity:.6;cursor:wait}
    .pf-gift-panel button.pf-gift-secondary{background:transparent;border-color:transparent;color:#24463a;font-size:12px;text-decoration:underline;text-underline-offset:3px}
    .pf-gift-panel button:focus-visible,.pf-gift-options summary:focus-visible,.pf-gift-panel a:focus-visible,.pf-gift-panel input:focus-visible{outline:2px solid #24463a;outline-offset:4px}
    #pf-gift-date{margin:16px 0;padding:20px;background:#f6f4ee;border:1px solid #d8d9d0;border-radius:6px}
    #pf-gift-date h2{font-size:27px;margin-bottom:8px}#pf-gift-date p{font-size:13px}
    .pf-gift-panel label{display:flex;align-items:flex-start;gap:12px;margin:16px 0;cursor:pointer;min-height:44px;font-size:14px}
    .pf-gift-panel input{width:22px;height:22px;flex-shrink:0;accent-color:#24463a;margin:0}
    #pf-gift-confirmed-date:not(:empty){padding:10px 12px;background:#e7eee3;color:#24463a;font-weight:600;border-radius:3px}
    .pf-gift-panel [role=alert]{color:#95382c!important}.pf-gift-panel [role=status]:empty,.pf-gift-panel [role=alert]:empty,#pf-gift-confirmed-date:empty{display:none}
    .pf-gift-active .additional-checkout-buttons,.pf-gift-active .shopify-payment-button{display:none!important}
    .pf-gift-reviewing #MainContent > :not(#pf-gift-review){display:none!important}
    @media(max-width:749px){
      #pf-gift-review{margin:22px auto 28px;padding:0 16px}.pf-gift-panel h2{font-size:32px}
      .pf-gift-intro{font-size:14px;margin-bottom:18px!important}.pf-gift-layout{grid-template-columns:minmax(0,1fr);gap:16px}
      .pf-gift-item{padding:16px}.pf-gift-item h3{font-size:21px}.pf-gift-thumb{width:52px;height:66px}.pf-gift-item-top{gap:10px}
      .pf-gift-price{font-size:13px}.pf-gift-message{padding:12px;margin-top:12px}.pf-gift-message blockquote{font-size:19px}
      .pf-gift-next{position:static;padding:18px}.pf-gift-next h3{font-size:24px}.pf-gift-actions{margin-top:14px}
      .pf-gift-panel button{width:100%}.pf-gift-option{grid-template-columns:minmax(0,1fr) minmax(0,1.2fr);gap:8px}
      #pf-gift-date{padding:16px}
    }
  `;
  document.head.append(css);
  function help(p) { p.append(element('a',phrases.help,{href:'mailto:info@persaflores.com'})); }
  function invalidate() {
    verifiedSelection = null;
    const details=document.getElementById('pf-gift-confirmed-date');if(details)details.textContent='';
    const check = document.getElementById('pf-gift-date-confirm'); if(check)check.checked=false;
  }
  function guardPanel() {
    if (!recovery || !/\/cart\/?$/.test(location.pathname)) return;
    document.documentElement.classList.add('pf-gift-active');
    const p = panel('pf-gift-date',phrases.dateHeading);
    document.querySelector('.cart__ctas')?.before(p);
    if (p.dataset.ready) return;
    p.dataset.ready='true';
    p.append(element('p',recovery.state === 'blocked' ? phrases.unavailable : phrases.saved));
    if (recovery.state === 'blocked') { help(p); return; }
    const label = element('label'), check = element('input','',{type:'checkbox',id:'pf-gift-date-confirm'});
    label.append(check,element('span',phrases.check));p.append(label);
    const details = element('p','',{id:'pf-gift-confirmed-date','aria-live':'polite'});p.append(details);
    const warning = element('p','',{id:'pf-gift-date-warning',role:'alert'});p.append(warning);
    check.addEventListener('change',async () => {
      if (!check.checked) { invalidate(); return; }
      check.disabled=true;
      try {
        const now = Date.now(), current = await cart('read');
        const date = current.attributes['Fecha de entrega'];
        const time = current.attributes['Hora de entrega '] || current.attributes['Hora de entrega'];
        const input = document.querySelector('input.uiDeliveryCalendar');
        qaStatus(JSON.stringify({fresh:!!selectionAt,selectedDay,date,time,input:input?.value}));
        if (!selectionAt || now-selectionAt>30*60000 || !C.validDate(date) || !time || input?.value !== date || date.split('/').reverse().join('-') !== selectedDay) throw new Error('Select date');
        verifiedSelection={date,time,signature:JSON.stringify([C.lines(current.items),current.note]),at:now};
        details.textContent=date+' · '+time; warning.textContent='';
      } catch (_) { invalidate();warning.textContent=phrases.needed; }
      finally { check.disabled=false; }
    });
  }
  // Only an enabled date-cell click in the vendor calendar satisfies a fresh choice.
  window.addEventListener('click',event => {
    if (!recovery || !event.isTrusted) return;
    const day = event.target.closest('.rmdp-day .sd[role=button][aria-disabled=false]');
    if (day) { selectionAt=Date.now();selectedDay=day.getAttribute('aria-label');invalidate(); }
    if (event.target.closest('.ant-select-item-option:not(.ant-select-item-option-disabled)')) invalidate();
  },true);
  async function confirmCheckout(event) {
    if(checking)return;
    if(!recovery){
      if(!allowed())return;
      event.preventDefault();event.stopImmediatePropagation();
      const target=event.target.closest('button,input[type=submit],a') || event.submitter;
      clearTimeout(timer);
      if(captureBusy)await new Promise(resolve=>{const start=Date.now();const id=setInterval(()=>{if(!captureBusy||Date.now()-start>5000){clearInterval(id);resolve();}},50);});
      await capture();
      checking=true;
      try{if(target)target.click();else event.target.requestSubmit();}finally{queueMicrotask(()=>{checking=false;});}
      return;
    }
    event.preventDefault();event.stopImmediatePropagation();
    const warning = document.getElementById('pf-gift-date-warning');
    if (recovery.state !== 'date' || !verifiedSelection || !document.getElementById('pf-gift-date-confirm')?.checked) {
      if(warning)warning.textContent=phrases.needed;
      document.getElementById('pf-gift-date')?.scrollIntoView({behavior:'smooth',block:'center'});return;
    }
    const target = event.target.closest('button,input[type=submit],a') || event.submitter;
    try {
      const current = await cart('read'), v=verifiedSelection;
      if(Date.now()-v.at>30*60000 || !C.validDate(v.date) || current.attributes['Fecha de entrega']!==v.date || (current.attributes['Hora de entrega ']||current.attributes['Hora de entrega'])!==v.time || JSON.stringify([C.lines(current.items),current.note])!==v.signature)throw new Error('Changed');
      await capture(true);
      // Replay the original control so Stellar computes the same shipping and draft checkout.
      checking=true;
      if(target)target.click();else event.target.requestSubmit();
      queueMicrotask(()=>{checking=false;});
    } catch (_) { invalidate();if(warning)warning.textContent=phrases.needed; }
  }
  window.addEventListener('click',event => {
    if(event.target.closest('[name=checkout],.cart__checkout-button,a[href="/checkout"],a[href="/en/checkout"]'))confirmCheckout(event);
  },true);
  window.addEventListener('submit',event => {
    if(event.submitter?.name==='checkout' || event.target.action?.endsWith('/checkout'))confirmCheckout(event);
  },true);
  const optionLabels = {
    Greens:['Verde adicional','Extra greenery'], 'Include message':['Incluir dedicatoria','Include message'], Mensaje:['Dedicatoria','Message'], signature:['Firma','Signature'], Recipient:['Destinatario','Recipient'], 'Incluir Jarrón':['Incluir jarrón','Include vase'], Style:['Jarrón','Vase'], 'Include chocolates':['Incluir bombones','Include chocolates'], Selection:['Bombones','Chocolates'], 'Plush toy animal':['Peluche','Soft toy'], Polaroid:['Foto Polaroid','Polaroid photo']
  };
  function optionText(key,value){
    const label=optionLabels[key]?.[language==='en'?1:0] || key;
    const choice=['Greens','Include message','Incluir Jarrón','Include chocolates','Plush toy animal','Polaroid'].includes(key);
    const text=choice && /^(si|sí|yes|no)$/i.test(value) ? (/^no$/i.test(value)?'No':language==='en'?'Yes':'Sí') : value;
    const translated=language==='en'?{'Jarrón Sakura':'Sakura Vase','Caja Roja Nestlé':'Nestlé Red Box'}:{};
    return [label, ['Style','Selection'].includes(key)?(translated[text]||text):text];
  }
  async function showRecovery(reference) {
    document.documentElement.classList.remove('pf-gift-reviewing');
    reviewing=true; clearTimeout(timer);
    document.getElementById('pf-gift-review')?.remove();
    const p = panel('pf-gift-review',phrases.heading);
    p.prepend(element('p',phrases.step,{class:'pf-gift-eyebrow'}));
    p.append(element('p',phrases.review,{class:'pf-gift-intro'}));
    const loading=element('p',phrases.loading,{role:'status'});p.append(loading);
    const images=new Map();
    let snapshot, current;
    try {
      const data = await request(endpoint+'/v1/recover/'+encodeURIComponent(reference),{credentials:'omit',referrerPolicy:'no-referrer',cache:'no-store'});
      snapshot=data.snapshot;current=await cart('read');
      C.lines(snapshot.items);
      await Promise.all(snapshot.items.map(async item=>{
        const local=current.items.find(i=>String(i.variant_id)===item.id);
        if(local){item.title=local.product_title||local.title;item.variant_title=local.variant_title||'';images.set(item.id,local.featured_image?.url||local.image);}
        if(item.handle && (!images.get(item.id) || snapshot.language!==language)){try{
          const product=await request(root+'products/'+encodeURIComponent(item.handle)+'.js',{});
          const variant=product.variants.find(v=>String(v.id)===item.id);
          if(!local){item.title=product.title;item.variant_title=variant?.public_title||'';}
          images.set(item.id,variant?.featured_image?.src||product.featured_image);
        }catch(_){}}
      }));
    } catch (_) { loading.remove();p.append(element('p',phrases.expired,{role:'alert'}));help(p);return; }
    loading.remove();
    document.documentElement.classList.add('pf-gift-reviewing');
    const layout=element('div','',{class:'pf-gift-layout'}), contents=element('div');
    const list = element('ul','',{class:'pf-gift-items',role:'list','aria-label':phrases.details});
    for(const item of snapshot.items){
      const li=element('li','',{class:'pf-gift-item'}), top=element('div','',{class:'pf-gift-item-top'});
      const image=images.get(item.id);
      if(image){try{
        const url=new URL(image,location.origin);
        if(url.protocol==='https:' && (url.hostname==='cdn.shopify.com'||url.hostname===location.hostname)){
          url.searchParams.set('width','160');
          const img=element('img','',{src:url.href,alt:'',width:'64',height:'80',class:'pf-gift-thumb',loading:'lazy'});
          img.addEventListener('error',()=>img.remove(),{once:true});top.append(img);
        }
      }catch(_){}}
      const info=element('div','',{class:'pf-gift-item-info'});
      const title=language==='en'?({'Jarrón Sakura':'Sakura Vase','Chocolates Caja Roja':'Red Box Chocolates'}[item.title]||item.title):item.title;
      info.append(element('h3',title),element('p',[item.variant_title,phrases.quantity+': '+item.quantity].filter(Boolean).join(' · '),{class:'pf-gift-meta'}));
      const price=element('div',money(item.original_price),{class:'pf-gift-price'});price.append(element('small',phrases.each));
      top.append(info,price);li.append(top);
      const entries=Object.entries(item.properties).filter(([key])=>!key.startsWith('_'));
      const messageKeys=['Mensaje','Message','Dedicatoria'];
      const messages=entries.filter(([key,value])=>messageKeys.includes(key)&&value);
      const personal=entries.filter(([key,value])=>['signature','Recipient','Firma','Destinatario'].includes(key)&&value);
      if(messages.length){
        const message=element('div','',{class:'pf-gift-message'});
        message.append(element('p',phrases.message,{class:'pf-gift-message-label'}));
        for(const [,value]of messages)message.append(element('blockquote',value));
        if(personal.length){const people=element('div','',{class:'pf-gift-personal'});for(const [key,value]of personal){const [label,text]=optionText(key,value);people.append(element('p',label+': '+text));}message.append(people);}
        li.append(message);
      }
      const extras=entries.filter(([key,value])=>['Greens','Style','Selection','Plush toy animal','Polaroid'].includes(key)&&value&&!/^no$/i.test(value)).map(([key,value])=>{const [label,text]=optionText(key,value);return /^(si|sí|yes)$/i.test(value)?label:label+': '+text;});
      if(extras.length)li.append(element('p',extras.join(' · '),{class:'pf-gift-option-summary'}));
      if(entries.length){
        const options=element('details','',{class:'pf-gift-options'}), summary=element('summary',phrases.allOptions);
        const dl=element('dl');
        for(const [key,value] of entries){const [label,text]=optionText(key,value), row=element('div','',{class:'pf-gift-option'});row.append(element('dt',label),element('dd',text));dl.append(row);}
        options.append(summary,dl);li.append(options);
      }
      list.append(li);
    }
    contents.append(list);
    if(snapshot.note)contents.append(element('p',phrases.note+': '+snapshot.note,{class:'pf-gift-contact'}));
    const next=element('div','',{class:'pf-gift-next'});
    next.append(element('h3',phrases.next),element('p',phrases.nextHelp));
    if(snapshot.attributes['Fecha de entrega'])next.append(element('p',phrases.savedDate+': '+snapshot.attributes['Fecha de entrega']+'. '+phrases.dateHelp,{class:'pf-gift-previous'}));
    if(current.items.length && !C.sameGift(snapshot,current))next.append(element('p',phrases.conflict,{class:'pf-gift-conflict'}));
    const restore=element('button',phrases.restore,{type:'button'}),keep=element('button',phrases.keep,{type:'button',class:'pf-gift-secondary'});
    const actions=element('div','',{class:'pf-gift-actions'});actions.append(restore,keep);next.append(actions);
    const status=element('p','',{role:'status'});next.append(status);
    layout.append(contents,next);p.append(layout);
    keep.addEventListener('click',()=>{document.documentElement.classList.remove('pf-gift-reviewing');reviewing=false;p.remove();document.getElementById('pf-gift-date')?.remove();sessionStorage.removeItem(SESSION);recovery=null;document.documentElement.classList.remove('pf-gift-active');history.replaceState(null,'',location.pathname+location.search);});
    restore.addEventListener('click',async()=>{
      restore.disabled=true;keep.disabled=true;status.textContent=phrases.busy;
      recovery={state:'blocked',started:Date.now()};storage(SESSION,recovery);internalMutation=true;
      try{
        current=await cart('read');
        const restored=await C.replace(snapshot,current,cart,backup=>storage(BACKUP,backup));
        sessionStorage.removeItem(BACKUP);
        recovery={state:'date',started:Date.now(),cartToken:restored.token};storage(SESSION,recovery);
        // Reload is needed for both Globo and Stellar to initialize on the restored lines.
        location.replace(root+'cart'+location.search);
      }catch(error){
        status.textContent=phrases.failed+' '+(error.rollback==='restored'?phrases.rollback:phrases.recoveryHelp);status.setAttribute('role','alert');help(p);
        if(error.rollback==='restored'){
          sessionStorage.removeItem(SESSION); sessionStorage.removeItem(BACKUP); recovery=null; keep.disabled=false;
          document.documentElement.classList.remove('pf-gift-active');
        }else guardPanel();
      }finally{internalMutation=false;}
    });
  }
  async function initializeRecovery(){
    const rawReference=new URLSearchParams(location.hash.slice(1)).get('pf-gift');
    if(rawReference && /\/cart\/?$/.test(location.pathname)) return showRecovery(rawReference.split('.')[0]);
    if(recovery?.cartToken){
      try { const current=await cart('read');if(!current.items.length || current.token!==recovery.cartToken){sessionStorage.removeItem(SESSION);recovery=null;} } catch(_){}
    }
    guardPanel();
  }
  window.addEventListener('hashchange',initializeRecovery);
  initializeRecovery();
  new MutationObserver(()=>{if(recovery && !document.getElementById('pf-gift-date') && !reviewing){invalidate();guardPanel();}}).observe(document.querySelector('main'),{childList:true,subtree:true});
  document.addEventListener('input',e=>{if(e.target.matches('textarea[name=note]'))scheduleCapture();});
  document.addEventListener('visitorConsentCollected',()=>{if(allowed())scheduleCapture();});
  function loadPrivacy(attempt=0){
    if(!window.Shopify?.loadFeatures){if(attempt<20)setTimeout(()=>loadPrivacy(attempt+1),500);return;}
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
      if(error){qaStatus('no se pudo cargar el permiso de cookies');return;}
      if(config.dataset.qa==='true'&&!allowed()){
        const button=element('button','Prueba interna: aceptar cookies de marketing y analítica',{type:'button'});
        button.addEventListener('click',()=>window.Shopify.customerPrivacy.setTrackingConsent({marketing:true,analytics:true},()=>{button.remove();scheduleCapture();}));
        document.querySelector('main').append(button);
      }
      scheduleCapture();
    });
  }
  loadPrivacy();
  qaStatus(allowed()?'iniciando guardado':'pendiente de permiso de marketing');
  scheduleCapture();
})();
